import r from "react";
import e from "prop-types";
import { S as y, T as f } from "./Tooltip-B-bmRvX4.es.js";
import { u as C } from "./ThemeProvider--i7ESlT5.es.js";
import { omit as b } from "lodash";
import h from "classnames";
import { I as k } from "./Icon-BuIPTPJn.es.js";
import { T as c } from "./index-BB-Wk85r.es.js";
import { u as H } from "./utils-C0l876fA.es.js";
import './TableHead.css';const T = e.shape({
  key: e.string.isRequired,
  label: e.string.isRequired,
  align: e.oneOf(["left", "right"]),
  renderCell: e.func,
  renderIcon: e.func,
  onCellClick: e.func,
  headerTooltip: e.shape({
    content: e.element.isRequired,
    props: e.shape(b(y, "children"))
  }),
  tooltipContent: e.func,
  LinkWrapper: e.elementType,
  sortable: e.bool
}), L = e.object, m = e.oneOf(["asc", "desc"]), p = "FixedContainer-module__fixedRow___1PhMe", x = "FixedContainer-module__fixedCol___DkcTy", d = {
  fixedRow: p,
  fixedCol: x
}, g = "#666", D = "ColumnHeaderCell-module__colHeader___YRk6X", R = "ColumnHeaderCell-module__right___Sh8q8", E = "ColumnHeaderCell-module__sortable___RNsyb", I = "ColumnHeaderCell-module__sortDirectionIcon___Rmbcl", v = "ColumnHeaderCell-module__hiddenText___zCH4m", w = "ColumnHeaderCell-module__stickyCol___nKejx", P = "ColumnHeaderCell-module__stickyHeader___9k9H9", l = {
  sortIconGray: g,
  colHeader: D,
  right: R,
  sortable: E,
  sortDirectionIcon: I,
  hiddenText: v,
  stickyCol: w,
  stickyHeader: P
}, a = (t) => {
  const { t: i } = H(), n = {
    className: h(
      l.colHeader,
      t.align === "right" && l.right,
      d.fixedRow,
      t.fixedCol && d.fixedCol,
      t.stickyCol && l.stickyCol,
      t.stickyHeader && l.stickyHeader,
      t.sortable && l.sortable
    ),
    scope: "col",
    tabIndex: 0
  };
  if (!t.sortable)
    return /* @__PURE__ */ r.createElement("th", { ...n }, /* @__PURE__ */ r.createElement(c.DataHeader, { responsive: !0 }, t.children));
  let o = "none";
  return t.sortDirection === "asc" ? o = "ascending" : t.sortDirection === "desc" && (o = "descending"), /* @__PURE__ */ r.createElement(
    "th",
    {
      onClick: t.sortBy,
      onKeyDown: (s) => {
        ["Enter", " "].includes(s.key) && t.sortBy();
      },
      "aria-sort": o,
      ...n
    },
    t.sortDirection !== void 0 && /* @__PURE__ */ r.createElement(
      k,
      {
        size: 10,
        className: l.sortDirectionIcon,
        color: l.sortIconGray,
        name: t.sortDirection === "asc" ? "pointed_arrow_up" : "pointed_arrow_down",
        testId: `icon-${t.sortDirection}`
      }
    ),
    /* @__PURE__ */ r.createElement("span", { className: l.text }, /* @__PURE__ */ r.createElement(c.DataHeader, { responsive: !0 }, t.children)),
    /* @__PURE__ */ r.createElement("span", { className: l.hiddenText }, i("click to sort by this column"))
  );
};
a.propTypes = {
  children: e.node.isRequired,
  align: e.oneOf(["left", "right"]),
  sortable: e.bool,
  sortBy: e.func,
  sortDirection: m,
  fixedCol: e.bool,
  stickyCol: e.bool,
  stickyHeader: e.bool
};
a.defaultProps = {
  align: "left",
  sortable: !1,
  sortBy: () => {
  },
  sortDirection: void 0,
  fixedCol: !1,
  stickyCol: !1,
  stickyHeader: !0
};
const q = "TableHead-default-module__label___FWgvc", u = {
  label: q
}, B = "TableHead-compere-module__label___z24lk", N = {
  label: B
}, F = {
  default: u,
  compere: N
}, _ = (t) => {
  const i = C(), n = F[i] || u;
  return /* @__PURE__ */ r.createElement("thead", null, /* @__PURE__ */ r.createElement("tr", null, t.columns.map((o, s) => /* @__PURE__ */ r.createElement(
    a,
    {
      key: s,
      align: o.align,
      fixedCol: s === 0,
      colHeader: !0,
      stickyCol: s === 0 && t.stickFirstColumn,
      sortable: o.sortable,
      sortBy: () => t.sortBy(o.key),
      sortDirection: o.key === t.sortColumn ? t.sortDirection : void 0,
      stickyHeader: t.stickyHeader
    },
    o.headerTooltip && typeof o.headerTooltip == "object" && o.headerTooltip.content && o.headerTooltip.props ? /* @__PURE__ */ r.createElement(
      f.Hover,
      {
        ...o.headerTooltip.props,
        accessible: !0,
        trigger: /* @__PURE__ */ r.createElement("span", { className: n.label }, o.label)
      },
      o.headerTooltip.content
    ) : o.label
  ))));
};
_.propTypes = {
  columns: e.arrayOf(T.isRequired).isRequired,
  stickFirstColumn: e.bool,
  sortBy: e.func.isRequired,
  sortColumn: e.string,
  sortDirection: m,
  stickyHeader: e.bool
};
_.defaultProps = {
  stickFirstColumn: !1,
  sortColumn: void 0,
  sortDirection: void 0,
  stickyHeader: !0
};
export {
  _ as T,
  T as c,
  d as f,
  L as r,
  m as s
};
